exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-design-workflow-drawer .tab-header{align-items:center;display:flex;gap:4px;margin-bottom:12px}.fts-design-workflow-drawer .tab-title{font-weight:var(--inistate-font-weight-medium);font-size:var(--inistate-paragraph-text-16);line-height:var(--inistate-paragraph-text-16--line-height);color:var(--inistate-text-secondary)}.fts-design-workflow-drawer .tab-hint{height:20px;width:20px;display:flex;align-items:center;justify-content:center}.fts-design-workflow-drawer .tab-hint-icon{font-size:18px;color:var(--inistate-icon-primary)}", ""]);

// exports
